import { Checkbox as BaseCheckbox } from '@base-ui/react/checkbox';
import { CheckboxGroup as BaseCheckboxGroup } from '@base-ui/react/checkbox-group';
import * as stylex from '@stylexjs/stylex';
import '../../../../styles/tokens.stylex';
import { borderRadius, easing, shadow, size, spacing, timing } from '../../../../styles/tokens.stylex';
import '../../markers.stylex';
import { checkableMarker, inputIconMarker, labelMarker } from '../../markers.stylex';
import '../../form.tokens.stylex';
import { formTokens } from '../../form.tokens.stylex';
import { MaxColumnGrid } from '@/components/MaxColumnGrid';
import { use } from 'react';
import { FieldControlContext } from './Field';
import { Check } from 'lucide-react';
type BaseUICompositeType<T> = {
  styles?: stylex.StyleXStyles;
} & T;
function Root(props: BaseUICompositeType<BaseCheckbox.Root.Props>) {
  return <BaseCheckbox.Root {...props} {...stylex.props(checkableMarker, sx.root, props.styles)} />;
}
function Indicator(props: BaseUICompositeType<BaseCheckbox.Indicator.Props>) {
  return <BaseCheckbox.Indicator keepMounted {...props} {...stylex.props(sx.indicator, props.styles)} render={<Check strokeWidth={3} strokeLinecap="square" />} />;
}
function CheckboxGroup({
  columns = 1,
  ...props
}: BaseUICompositeType<BaseCheckboxGroup.Props> & {
  columns?: number;
}) {
  const fieldControl = use(FieldControlContext);
  return <BaseCheckboxGroup {...fieldControl} {...props} render={<MaxColumnGrid maxColumns={columns} minColumnWidth="xs" gap="sm" styles={[sx.checkboxGroup, props.styles]} />} />;
}
export const Checkbox = {
  Root,
  Indicator,
  CheckboxGroup
};
const sx = {
  root: {
    kVAM5u: "xwsnfrh x16m9s1f x1nbio5p",
    kaIpWk: "xlhn99x",
    ksu8eU: "x1y0btm7",
    kMzoRj: "x1q469ie",
    kGNEyG: "x6s0dn4",
    kWkggS: "x1o47r4 xj4d6mi",
    kGVxlE: "xw90h5g",
    k1xSpc: "x78zum5",
    kmuXW: "x2lah0s",
    k87sOh: "xy11dvg",
    kLqNvP: "x1vt5lg4",
    kjj79g: "xl56j7k",
    kVQacm: "x7giv3",
    kVAEAm: "x1u5hf2f",
    kZKoxP: "xxk0z11",
    kzqmXN: "xvy4d1p",
    $$css: true
  },
  indicator: {
    kaIpWk: "x2u8bby",
    kmkexE: "x9lqykl",
    kMwMTN: "xi66jyo",
    k1xSpc: "x1lliihq",
    kSiTet: "xg01cxk xdavzed xyn2shw",
    kZKoxP: "xqwie1i",
    kzqmXN: "xs02qll",
    $$css: true
  },
  checkboxGroup: {
    $$css: true
  }
};